// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__32Vng","notes":"Notes_notes__1ZBQ8","note":"Notes_note__IGwA-","markdown":"Notes_markdown__XZKWH"};